export enum ORGANIZATION_PARTNER_TYPE {
  CUSTOMER = "CUSTOMER",
  DESIGN_PARTNER = "DESIGN_PARTNER",
  SUPPLIER_PARTNER = "SUPPLIER_PARTNER",
  SERVICE_PARTNER = "SERVICE_PARTNER",
}
